export default "__VITE_ASSET__DJtaNsMS__"